import Page from '../../components/Page';
import LoadingModal from '@raydiant/raydial/components/LoadingModal';
import { RouteComponentProps } from 'react-router-dom';
import useConnection from '../../hooks/useConnection';
import ProductHubEditGuidIntegrationPage from './ProductHubEditGuidIntegrationPage';
import ProductHubEditOAuthIntegrationPage from './ProductHubEditOAuthIntegrationPage';

type RouteParams = {
  integrationId: string;
};

const ProductHubEditIntegrationRouter = (
  props: RouteComponentProps<RouteParams>,
) => {
  const { params } = props.match;
  const { integrationId } = params;
  const connectionQuery = useConnection(integrationId);
  const { data: connection } = connectionQuery;

  if (connectionQuery.isLoading) {
    return (
      <Page>
        <LoadingModal isOpen={true} />
      </Page>
    );
  }

  if (!connection) {
    return null;
  }

  const selectedConnector = connection.connector.name;

  return (
    <>
      {selectedConnector === 'toast' && (
        <ProductHubEditGuidIntegrationPage
          connection={connection}
          type="toast"
        />
      )}
      {selectedConnector === 'qsr' && (
        <ProductHubEditGuidIntegrationPage connection={connection} type="qsr" />
      )}
      {['square', 'lightspeed'].includes(selectedConnector) && (
        <ProductHubEditOAuthIntegrationPage connection={connection} />
      )}
    </>
  );
};

export default ProductHubEditIntegrationRouter;
